/* eslint-disable import/prefer-default-export -- Intentionally using named export */
import React from "react";

import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import Trans from "@/components/Trans/Trans";
import { ROUTES } from "@/constants";

interface IPlanLinksProps {
  planNames: string[] | undefined;
}

export const PlanLinks = ({ planNames }: IPlanLinksProps) => {
  return (
    <span data-testid="SubscriptionPlanLinks">
      {planNames?.map((planName, index) => (
        <React.Fragment key={planName}>
          <LocalizedLink to={ROUTES.subscribe} className="font-bold underline">
            {planName}
          </LocalizedLink>{" "}
          {index + 1 < planNames.length ? <Trans i18nKey="chat:modal.upgradePlan.or" /> : ""}{" "}
        </React.Fragment>
      ))}
    </span>
  );
};
